import * as $ from 'jquery';
import { IEventAggregator } from 'common/eventaggregator';
import { IResourceProvider } from 'common/resourceprovider';

import { IMethodRouter } from 'runtime/methodrouter';
import { IValueStore } from 'runtime/valuestore';
import { ControlArgs } from 'runtime/controls/controlargs';
import { ContainerControl } from 'runtime/controls/containercontrol';
import { Serializer } from 'common/serializer';

import { Map } from 'immutable';

let bindings = Map<string, any>();

export function registerBinding(name: string, control: any) {
    bindings = bindings.set(name.toLowerCase(), control);
}

export function applyBindings($elements: JQuery, fieldContext: string, eventAggregator: IEventAggregator, methods: IMethodRouter, values: IValueStore, resources: IResourceProvider, container: ContainerControl, serializer: Serializer) {
    $elements.each((i, e) => {
        var $element = $(e);
        var binding = $element.attr('data-bind');

        if (!binding)
            return;

        var typeName = binding.substring(0, binding.indexOf(':'));
        var type = bindings.get(typeName);

        if (!!type) {
            $element.data('control', new type(new ControlArgs($element[0], JSON.parse(binding.substring(typeName.length + 2)), eventAggregator, methods, values, fieldContext, resources, container, serializer)));
        }
    });
}

export function readBinding($element: JQuery, bindingName: string) {
    var binding = $element.attr('data-bind');
    if (!binding)
        return null;

    if (binding.indexOf(bindingName) !== 0)
        return null;

    return JSON.parse(binding.substring(bindingName.length + 2));
}

export function getElementBindings($elements: JQuery, bindingName: string) {
    return $elements.toArray().map(x => $(x)).map(x => ({ element: x, binding: readBinding(x, bindingName) })).filter(x => x.binding !== null);
}

export function registeredBindings() {
    return bindings;
}